import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderSkeletonComponent } from './skeleton.component';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';


@NgModule({
  declarations: [
    RappiderSkeletonComponent
  ],
  imports: [
    CommonModule,
    NzSkeletonModule
  ],
  exports: [
    RappiderSkeletonComponent
  ]
})
export class RappiderSkeletonModule { }
